// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles pour l'onglet Gestion d'équipe - Style PJ1
 * Cohérent avec GestionComptes.css et App.css
 */

.tab-equipe {
  padding: 0;
  margin: 0 auto;
  width: 100%;
}

.tab-equipe.loading,
.tab-equipe.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 1rem;
}

.tab-equipe .loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #D97947;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Section - Utilise les styles globaux de App.css */
.equipe-section {
  margin-bottom: 2rem;
}

/* Header de section - Style PJ1 */
.equipe-section .section-header {
  background-color: #595959;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem;
  color: #fffdfc;
}

.equipe-section .section-header h2 {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
  color: #fffdfc;
}

/* Contenu de section - Style PJ1 */
.equipe-section .section-content {
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 2rem;
}

/* Toolbar avec recherche et bouton - Style GestionComptes */
.section-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 1rem;
}

.search-bar {
  position: relative;
  flex: 1 1;
  max-width: 350px;
}

.search-bar .search-input {
  width: 100%;
  padding: 10px 16px 10px 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.4rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-bar .search-input:focus {
  outline: none;
  border-color: #D97947;
  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);
}

.search-bar .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.6rem;
  color: #9ca3af;
}

/* Tables - Style GestionComptes/TableauDeBord */
.membres-table-container {
  overflow-x: auto;
}

.membres-table {
  width: 100%;
  border-collapse: collapse;
}

.membres-table th {
  background: #f9fafb;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 1.4rem;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
}

.membres-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 1.4rem;
  color: #2c3948;
}

.membres-table tbody tr:hover {
  background: #f9fafb;
}

.membres-table tbody tr:last-child td {
  border-bottom: none;
}

/* Colonnes spécifiques - Style GestionComptes */
.user-name {
  font-size: 1.4rem;
  color: #2c3948;
  font-weight: 500;
}

.user-email {
  font-size: 1.4rem;
  color: #2c3948;
}

.user-phone {
  font-size: 1.4rem;
  color: #2c3948;
}

.user-fonction {
  font-size: 1.4rem;
  color: #2c3948;
}

.user-role {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #2c3948;
  font-size: 1.4rem;
}

.user-role span {
  text-decoration: none;
}

.creation-date {
  font-size: 1.4rem;
  color: #2c3948;
}

.no-data {
  text-align: center;
  color: #9ca3af;
  padding: 2rem 1rem !important;
  font-style: italic;
  font-size: 1.4rem;
}

/* Actions - Style PJ1 avec boutons orange */
.actions-cell {
  white-space: nowrap;
}

.action-btn {
  padding: 8px 16px;
  border: 1px solid #da7027;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 8px;
  background: #da7027;
  color: white;
}

.action-btn:last-child {
  margin-right: 0;
}

.action-btn:hover {
  background: #c4631f;
  border-color: #c4631f;
}

.action-btn.action-password {
  background: white;
  color: #374151;
  border-color: #d1d5db;
}

.action-btn.action-password:hover {
  background: #f3f4f6;
}

.action-disabled {
  color: #9ca3af;
  font-size: 1.2rem;
  font-style: italic;
}

/* Modals - Style PJ1 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: #fffdfc;
  border-radius: 0.8rem;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-content.confirm-modal {
  max-width: 400px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3948;
}

.modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: #6b7280;
}

.modal-body {
  padding: 2rem;
}

.modal-body p {
  margin: 0 0 1rem;
  color: #6b7280;
  line-height: 1.5;
  font-size: 1.4rem;
}

.modal-body .modal-info {
  font-size: 1.4rem;
  color: #6b7280;
  background: #f9fafb;
  padding: 1rem;
  border-radius: 6px;
  margin-top: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

/* Form dans modal - Style PJ1 */
.modal-body .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.modal-body .form-group {
  margin-bottom: 16px;
}

.modal-body .form-group:last-child {
  margin-bottom: 0;
}

.modal-body .form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.modal-body .form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 1.4rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.modal-body .form-group input:focus {
  outline: none;
  border-color: #D97947;
  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);
}

.modal-body .form-group input.error {
  border-color: #dc3545;
}

.modal-body .form-group .error-message {
  display: block;
  margin-top: 4px;
  font-size: 1.2rem;
  color: #dc3545;
}

/* Responsive */
@media (max-width: 768px) {
  .section-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .search-bar {
    max-width: none;
  }

  .modal-body .form-row {
    grid-template-columns: 1fr;
  }

  .membres-table th,
  .membres-table td {
    padding: 8px 12px;
    font-size: 1.2rem;
  }
}

/* Section Affectations - Filtres */
.filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  align-items: flex-end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 180px;
}

.filter-group label {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
}

.filter-group select {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.4rem;
  color: #2c3948;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.filter-group select:focus {
  outline: none;
  border-color: #D97947;
  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);
}

.filter-group.filter-actions {
  min-width: auto;
}

.btn-reset-filters {
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  background: white;
  color: #374151;
  transition: all 0.2s;
}

.btn-reset-filters:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.btn-reset-filters:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Table générique */
.table-container {
  overflow-x: auto;
}

.equipe-table {
  width: 100%;
  border-collapse: collapse;
}

.equipe-table th {
  background: #f9fafb;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 1.4rem;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
}

.equipe-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 1.4rem;
  color: #2c3948;
}

.equipe-table tbody tr:hover {
  background: #f9fafb;
}

.equipe-table tbody tr:last-child td {
  border-bottom: none;
}

.equipe-table .empty-message {
  text-align: center;
  color: #9ca3af;
  padding: 2rem 1rem !important;
  font-style: italic;
}

/* Badges de type */
.type-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 500;
}

.type-badge.type-reference {
  background: #e0f2fe;
  color: #0369a1;
}

.type-badge.type-titulaire {
  background: #dcfce7;
  color: #15803d;
}

/* Badges de rôle */
.role-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 500;
  background: #f3f4f6;
  color: #374151;
}

.role-badge.role-administrateur {
  background: #fef3c7;
  color: #92400e;
}

.role-badge.role-utilisateur {
  background: #e5e7eb;
  color: #374151;
}

/* Footer de tableau */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.count-info {
  font-size: 1.3rem;
  color: #6b7280;
}

/* Nom cliquable dans tableau */
.name-cell {
  font-weight: 500;
  color: #2c3948;
}

/* Responsive filtres */
@media (max-width: 768px) {
  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    min-width: 100%;
  }

  .equipe-table th,
  .equipe-table td {
    padding: 8px 12px;
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabEquipe.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,UAAU;EACV,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * Styles pour l'onglet Gestion d'équipe - Style PJ1\n * Cohérent avec GestionComptes.css et App.css\n */\n\n.tab-equipe {\n  padding: 0;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.tab-equipe.loading,\n.tab-equipe.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  gap: 1rem;\n}\n\n.tab-equipe .loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #D97947;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Section - Utilise les styles globaux de App.css */\n.equipe-section {\n  margin-bottom: 2rem;\n}\n\n/* Header de section - Style PJ1 */\n.equipe-section .section-header {\n  background-color: #595959;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  padding: 1rem;\n  color: #fffdfc;\n}\n\n.equipe-section .section-header h2 {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0;\n  color: #fffdfc;\n}\n\n/* Contenu de section - Style PJ1 */\n.equipe-section .section-content {\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-top: none;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  padding: 2rem;\n}\n\n/* Toolbar avec recherche et bouton - Style GestionComptes */\n.section-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 1rem;\n}\n\n.search-bar {\n  position: relative;\n  flex: 1;\n  max-width: 350px;\n}\n\n.search-bar .search-input {\n  width: 100%;\n  padding: 10px 16px 10px 40px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.4rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.search-bar .search-input:focus {\n  outline: none;\n  border-color: #D97947;\n  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);\n}\n\n.search-bar .search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.6rem;\n  color: #9ca3af;\n}\n\n/* Tables - Style GestionComptes/TableauDeBord */\n.membres-table-container {\n  overflow-x: auto;\n}\n\n.membres-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.membres-table th {\n  background: #f9fafb;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 1.4rem;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.membres-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.membres-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.membres-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Colonnes spécifiques - Style GestionComptes */\n.user-name {\n  font-size: 1.4rem;\n  color: #2c3948;\n  font-weight: 500;\n}\n\n.user-email {\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.user-phone {\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.user-fonction {\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.user-role {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  color: #2c3948;\n  font-size: 1.4rem;\n}\n\n.user-role span {\n  text-decoration: none;\n}\n\n.creation-date {\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.no-data {\n  text-align: center;\n  color: #9ca3af;\n  padding: 2rem 1rem !important;\n  font-style: italic;\n  font-size: 1.4rem;\n}\n\n/* Actions - Style PJ1 avec boutons orange */\n.actions-cell {\n  white-space: nowrap;\n}\n\n.action-btn {\n  padding: 8px 16px;\n  border: 1px solid #da7027;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 8px;\n  background: #da7027;\n  color: white;\n}\n\n.action-btn:last-child {\n  margin-right: 0;\n}\n\n.action-btn:hover {\n  background: #c4631f;\n  border-color: #c4631f;\n}\n\n.action-btn.action-password {\n  background: white;\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n.action-btn.action-password:hover {\n  background: #f3f4f6;\n}\n\n.action-disabled {\n  color: #9ca3af;\n  font-size: 1.2rem;\n  font-style: italic;\n}\n\n/* Modals - Style PJ1 */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal-content {\n  background: #fffdfc;\n  border-radius: 0.8rem;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-content.confirm-modal {\n  max-width: 400px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: #6b7280;\n}\n\n.modal-body {\n  padding: 2rem;\n}\n\n.modal-body p {\n  margin: 0 0 1rem;\n  color: #6b7280;\n  line-height: 1.5;\n  font-size: 1.4rem;\n}\n\n.modal-body .modal-info {\n  font-size: 1.4rem;\n  color: #6b7280;\n  background: #f9fafb;\n  padding: 1rem;\n  border-radius: 6px;\n  margin-top: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 1.5rem 2rem;\n  border-top: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n/* Form dans modal - Style PJ1 */\n.modal-body .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.modal-body .form-group {\n  margin-bottom: 16px;\n}\n\n.modal-body .form-group:last-child {\n  margin-bottom: 0;\n}\n\n.modal-body .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.modal-body .form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 1.4rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.modal-body .form-group input:focus {\n  outline: none;\n  border-color: #D97947;\n  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);\n}\n\n.modal-body .form-group input.error {\n  border-color: #dc3545;\n}\n\n.modal-body .form-group .error-message {\n  display: block;\n  margin-top: 4px;\n  font-size: 1.2rem;\n  color: #dc3545;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .section-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-bar {\n    max-width: none;\n  }\n\n  .modal-body .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .membres-table th,\n  .membres-table td {\n    padding: 8px 12px;\n    font-size: 1.2rem;\n  }\n}\n\n/* Section Affectations - Filtres */\n.filters-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n  align-items: flex-end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 180px;\n}\n\n.filter-group label {\n  font-size: 1.3rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.filter-group select {\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.4rem;\n  color: #2c3948;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: #D97947;\n  box-shadow: 0 0 0 3px rgba(217, 121, 71, 0.1);\n}\n\n.filter-group.filter-actions {\n  min-width: auto;\n}\n\n.btn-reset-filters {\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.3rem;\n  font-weight: 500;\n  cursor: pointer;\n  background: white;\n  color: #374151;\n  transition: all 0.2s;\n}\n\n.btn-reset-filters:hover:not(:disabled) {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.btn-reset-filters:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Table générique */\n.table-container {\n  overflow-x: auto;\n}\n\n.equipe-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.equipe-table th {\n  background: #f9fafb;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 1.4rem;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.equipe-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 1.4rem;\n  color: #2c3948;\n}\n\n.equipe-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.equipe-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.equipe-table .empty-message {\n  text-align: center;\n  color: #9ca3af;\n  padding: 2rem 1rem !important;\n  font-style: italic;\n}\n\n/* Badges de type */\n.type-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n.type-badge.type-reference {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.type-badge.type-titulaire {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n/* Badges de rôle */\n.role-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: 500;\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.role-badge.role-administrateur {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.role-badge.role-utilisateur {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n/* Footer de tableau */\n.table-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.count-info {\n  font-size: 1.3rem;\n  color: #6b7280;\n}\n\n/* Nom cliquable dans tableau */\n.name-cell {\n  font-weight: 500;\n  color: #2c3948;\n}\n\n/* Responsive filtres */\n@media (max-width: 768px) {\n  .filters-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-group {\n    min-width: 100%;\n  }\n\n  .equipe-table th,\n  .equipe-table td {\n    padding: 8px 12px;\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
